import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import AccountantsPage from './AccountantsPage'
import NewClientPage from './NewClientPage'
import ShowClientPage from './ShowClientPage'
import Card from '../core/Card'
import './Accountants.css'

const routes = [
  { path: `/accountants`,
    exact: true,
    main: AccountantsPage
  },
  // NOTE consider this as a cleaner approach to manage "tabs" view, which can be positioned strategically based on device used
  { path: `/accountants/clients`,
    exact: true,
    main: AccountantsPage
  },
  { path: `/accountants/clients/new`,
    main: NewClientPage
  },
  { path: `/accountants/clients/:token_id`,
    main: ShowClientPage
  }
]

const Tabs = ({match}) =>
  <Card gridArea="Tabs" className="Tabs">
    <ul>
      <li>
        <Link to={`${match.url}/clients`}>
          All Clients
        </Link>
      </li>
      <li>
        <Link to={`${match.url}/clients/new`}>
          Add New Clients
        </Link>
      </li>

    </ul>
  </Card>

const Accountants = ({match}) => (
  <div className="Accountants">
    {/* Commenting out for now, we don't want to enable add member route until user has created an accountant group
    <Tabs match={match}/>
    */}
    <Card className="Main">
      <Switch>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.main}
          />
        ))}
      </Switch>
    </Card>
  </div>
)

export default Accountants



// WEBPACK FOOTER //
// ./src/accountants/Accountants.js